import axios from 'axios'
import Utils from '@/common/Utils'

const headers = { 'Content-Type': 'application/json' }

const url = `${process.env.VUE_APP_UTILS_API}/api`

export default class RegionsService {
    static async getCountries (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/paises`, { headers, params })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getStates (countryCode = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/estados`, { headers, params: { countryCode } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getLocations (stateId = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/municipios`, { headers, params: { stateId, sepomex: true, active: true } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getColonies (codigoPostal = '', municipioId = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/colonias`, { headers, params: { codigoPostal, municipioId } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getCities (stateId = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/ciudades`, { headers, params: { stateId } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getStateIdByName (stateName = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/estados`, { headers, params: { stateName } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
    static async getLocationIdByName (locationName = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/sepomex/municipios`, { headers, params: { locationName } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
